import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { bank_account_change_form_keys } from './bank-account-change-isv.constants';
import { IIbanObject } from 'src/app/modules/athora/athora.constants';

@Component({
  selector: 'app-bank-account-change-isv',
  templateUrl: './bank-account-change-isv.component.html',
  styleUrl: './bank-account-change-isv.component.scss'
})
export class BankAccountChangeIsvComponent implements OnChanges {

  @Input() form: FormGroup;
  @Input() isReadOnly: boolean;
  @Input() ibanList: IIbanObject[] = [];
  @Input() currentBankAccount: string;

  formKeys: IFormKey[] = CommonUtils.assign(bank_account_change_form_keys);

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['ibanList'] && changes['ibanList'].currentValue) {
        this.populateIbanOptions();
      }
  }

  populateIbanOptions(): void {
    this.formKeys = CommonUtils.populateIbanOptions(this.formKeys, this.ibanList, true);
  }

  get showErrorMessage(): boolean {
    return this.ibanList && this.ibanList.length === 1 && this.ibanList.some(obj => obj?.abiRapporto + obj?.cabRapporto + obj?.numeroRapporto === this.currentBankAccount);
  }

}
